import { useCallback } from 'react';
import { shallow as shallow$1 } from '../../../node_modules/zustand/esm/shallow.js';
import { useAssistantStore } from '../stores/assistantStore.js';
import { AssistantEphemeralContextSubType } from '../types.js';
import { pick } from 'lodash-es';
import { useShowExpandedResource } from '../../resources/stores/useExpandedResourceStore.js';

const useAskAssistantItem = () => {
  const { setLastContextSubtype, setPersistentContext } = useAssistantStore((state) => pick(state, [
    "setLastContextSubtype",
    "setPersistentContext"
  ]), shallow$1);
  const showExpandedResource = useShowExpandedResource();
  return useCallback((resource) => {
    setPersistentContext({
      resourceIds: [],
      textSnippets: []
    });
    setLastContextSubtype(AssistantEphemeralContextSubType.File);
    showExpandedResource(resource.id, {
      tab: "assistant"
    });
  }, [
    setPersistentContext,
    setLastContextSubtype,
    showExpandedResource
  ]);
};

export { useAskAssistantItem };
//# sourceMappingURL=useAskAssistantItem.js.map
